import { Button } from "@/src/components/buttons";
import { Card } from "@/src/components/cards";
import { openConfirmDialog } from "@/src/components/dialogs";
import { Discharge, Hospitalisation, Patient } from "@/src/data/allTypes";
import apiFetch from "@/src/utils/apiFetch";
import {
  formatDate,
  getDayCount,
  getItemId,
  getUserId,
  getUserShortName,
  isToday,
} from "@/src/utils/utils";
import { openDischargeDrawer } from "./dischargeButton";
import moment from "moment";

export default function DischargeCard({
  item,
  patient,
  parent,
  onClick,
  onChange,
}: {
  item: Discharge;
  patient: Patient;
  parent: Hospitalisation;
  onClick: () => void;
  onChange: (item: Discharge) => void;
}) {
  function getStatusName(item: Discharge) {
    if (item.status == "pending") return "En attente";
    if (item.status == "waitingForValidation") return "En attente";
    if (item.status == "validated") return "Validée";
    if (item.status == "finished") return "Terminée";
    if (item.status == "canceled") return "Rejetée";
    return "";
  }

  if (!item) return null;

  return (
    <Card
      color={"blue"}
      leading={
        <div className=" mtop5 left br mright5">
          <div className="bold">{getDayCount(parent?._date, item._date)}</div>
          <div className="gray">{formatDate(item._date, "HH:mm")}</div>
        </div>
      }
      title={`Sortie (${getStatusName(item)})`}
      subTitle={
        <div>
          <div>Faite par {getUserShortName(item.creator)}</div>
        </div>
      }
      onEdit={() => {
        openDischargeDrawer({
          parent,
          discharge: item,
          patient,
          onSave: (discharge) => {
            onChange(discharge);
          },
        });
      }}
      onClick={async () => {
        await onClick();
      }}
      onDelete={
        getUserId() == getItemId(item.creator) && isToday(item._date)
          ? async () => {
              await openConfirmDialog({
                content: "Voulez-vous vraiment supprimer cet élément ?",
                onConfirm: async () => {
                  await apiFetch("discharges", "deleteOne", {
                    id: item.id,
                  });
                  onChange?.(item);
                },
              });
            }
          : undefined
      }
    >
      <div className="c1 gap10">
        <div>
          Prévue le <strong>{formatDate(item.exitDate, "LL")}</strong>{" "}
        </div>

        {item.status == "pending" && (
          <Button
            onClick={async () => {
              item.dischargeType = "immediate";
              await openDischargeDrawer({
                parent,
                discharge: item,
                patient,
                onSave: (discharge) => {
                  onChange(discharge);
                },
              });
            }}
                 
            type={"tertiary"}
          >
            Faire sortir définitivement
          </Button>
        )}
      </div>
    </Card>
  );
}
